/** @format */

import { ComponentFactory, ComponentFactoryResolver, NgModule } from '@angular/core';

import { CategoryHeaderModule } from '@category/components';
import { CommonModule } from '@angular/common';
import { GoogleAdManagerComponent } from '@shared/components';
import { TemplateOneSpotComponent } from './template-onespot.component';

@NgModule({
	declarations: [TemplateOneSpotComponent],
	imports: [CategoryHeaderModule, CommonModule, GoogleAdManagerComponent]
})
export class TemplateOneSpotModule {
	constructor(private resolver: ComponentFactoryResolver) {}

	public resolveComponentFactory(): ComponentFactory<TemplateOneSpotComponent> {
		return this.resolver.resolveComponentFactory(TemplateOneSpotComponent);
	}
}
